import { render, staticRenderFns } from "./PlayersTable.vue?vue&type=template&id=062a3dc6&scoped=true&"
import script from "./PlayersTable.vue?vue&type=script&lang=js&"
export * from "./PlayersTable.vue?vue&type=script&lang=js&"
import style0 from "./PlayersTable.vue?vue&type=style&index=0&id=062a3dc6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "062a3dc6",
  null
  
)

export default component.exports